import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ContactService {
  constructor(private readonly http: HttpClient) {}

  sendMessage(email: string, subject: string, description: string): Observable<void> {
    return this.http.post<void>(`${environment.apiUrl}/messages`, {
      email,
      subject,
      description,
    });
  }
}
